module.exports = __webpack_public_path__ + "static/media/f.c3872006.png";